/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_InfoInputs */



/**

* @param {Footer_InfoInputs} inputs
* @param {{ locale?: "es" }} options
* @returns {LocalizedString}
*/
export const footer_info = /** @type {((inputs?: Footer_InfoInputs, options?: { locale?: "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_InfoInputs, { locale?: "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Información")
});